interface HeapConfig {
    environmentId: string;
    config?: Record<string, any>;
    userId?: string;
    userProperties?: Record<string, any>;
}

declare global {
    interface Window {
        heap: any;
        heapReadyCb: Array<{ name: string; fn: () => void }>;
    }
}

let heapInitialized = false;

export function initHeap(config: HeapConfig): void {
    if (typeof window === 'undefined') return;
    if (heapInitialized) return;

    if (!config?.environmentId) {
        console.warn('[Heap] Missing environmentId.');
        return;
    }

    heapInitialized = true;

    window.heapReadyCb = window.heapReadyCb || [];
    window.heap = window.heap || [];

    window.heap.load = function (envId: string, clientConfig: Record<string, any> = {}) {
        window.heap.envId = envId;
        window.heap.clientConfig = clientConfig;
        window.heap.clientConfig.shouldFetchServerConfig = false;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `https://cdn.us.heap-api.com/config/${envId}/heap_config.js`;

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode?.insertBefore(script, firstScript);

        const methods = [
            'init', 'startTracking', 'stopTracking', 'track', 'resetIdentity', 'identify', 'identifyHashed',
            'getSessionId', 'getUserId', 'getIdentity', 'addUserProperties', 'addEventProperties',
            'removeEventProperty', 'clearEventProperties', 'addAccountProperties', 'addAdapter',
            'addTransformer', 'addTransformerFn', 'onReady', 'addPageviewProperties',
            'removePageviewProperty', 'clearPageviewProperties', 'trackPageview'
        ];

        const stub = (name: string) => (...args: any[]) => {
            window.heapReadyCb.push({
                name,
                fn: () => {
                    if (window.heap?.[name]) {
                        window.heap[name](...args);
                    }
                }
            });
        };

        for (const method of methods) {
            window.heap[method] = stub(method);
        }
    };

    window.heap.load(config.environmentId, config.config || {});

    if (config.userId) {
        window.heap.identify(config.userId, config.userProperties || {});
    }
}

// Optional helper
export function identify(userId: string, userProperties: Record<string, any> = {}): void {
    if (typeof window.heap?.identify === 'function') {
        window.heap.identify(userId, userProperties);
    }
}
